import React from 'react';
import { IoIosArrowBack } from "react-icons/io";
import { IoMdRefresh } from "react-icons/io";
import { Button, Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
    const navigate = useNavigate();
    return (
        <Container className="flex-grow-1 py-5 d-flex align-items-center justify-content-center" style={{
            height: '100vh', overflow: 'hidden'
        }}>
            <Row className="justify-content-center align-items-center">
                <Col sm={12} className="order-md-1 order-2">
                    <div className="py-4">
                        <h1 className="display-1 fw-bold" style={{
                            fontSize: '250px',
                            background: 'linear-gradient(90deg, #00d0bb, #007ea9)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}>
                            404
                        </h1>

                        <div className="mt-4">
                            <h2 className="display-6 fw-bold text-dark">
                                Missing Tag
                            </h2>
                            <p className="text-secondary">
                                The URL you're looking for doesn't have a valid inventory tag. Please return to the dashboard
                            </p>

                            <div className="d-flex flex-column flex-sm-row gap-3 mt-4">
                                <Button onClick={() => { navigate('/') }} style={{ background: 'linear-gradient(90deg, #00d0bb, #007ea9)', border: 'none' }} className="rounded-pill transition-all d-flex align-items-center justify-content-center p-3 gap-2">
                                    <IoIosArrowBack size={18} />
                                    Return to Homepage
                                </Button>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container >
    )
};

export default PageNotFound;